// removed by extract-text-webpack-plugin
module.exports = {"text":"_2a3P"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/TextBanner/TextBanner.scss
// module id = mJr/
// module chunks = 0